import * as R from "ramda";
import { fork, takeEvery, all, put, take } from "redux-saga/effects";
import { actions } from "./model";
import { SIDEBAR_INSTANCE_ID } from "./constants";

import { actions as sliderSidebarActions } from "ui-kit/SliderSidebar/model";

const openMobileMenuFlyOver = function*({}) {
  yield put(
    sliderSidebarActions.setIsDrawerOpen(true, {
      meta: { instanceId: SIDEBAR_INSTANCE_ID }
    })
  );
};

const closeMobileMenuFlyOver = function*() {
  yield put(
    sliderSidebarActions.setIsDrawerOpen(false, {
      meta: { instanceId: SIDEBAR_INSTANCE_ID }
    })
  );
};

const watchOpenMobileMenuFlyOver = function*() {
  yield takeEvery(actions.openMobileMenuFlyOver.type, openMobileMenuFlyOver);
};
const watchCloseMobileMenuFlyOver = function*() {
  yield takeEvery(actions.closeMobileMenuFlyOver.type, closeMobileMenuFlyOver);
};

const watchExecuteAction = function*() {
  for (;;) {
    const action = yield take(actions.executeAction.type);
    const delegate = R.prop(action.payload.type, {});

    if (delegate) {
      yield fork(delegate, action);
    }
  }
};

const rootSaga = function*() {
  yield all([
    fork(watchExecuteAction),
    fork(watchOpenMobileMenuFlyOver),
    fork(watchCloseMobileMenuFlyOver)
  ]);
};
export default rootSaga;
